var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c("div", { staticClass: "login-form" }, [
      _c("div", { staticClass: "card card-login" }, [
        _c("div", { staticClass: "card-header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "text-login" }, [
            _vm._v(_vm._s(_vm.$t("general.system_name")))
          ])
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.handleSubmit.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _vm.errorMessage
                ? _c("div", { staticClass: "error-message error-login" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", [
                        _c("p", { staticClass: "fs-14 text-red font600" }, [
                          _vm._v(_vm._s(_vm.$t("error.title")))
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "fs-14 text-red font600",
                          domProps: { innerHTML: _vm._s(_vm.errorMessage) }
                        })
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-box" }, [
                _c("div", { staticClass: "text-center mt-1" }, [
                  _c("p", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("login.input_code_title")) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("login.input_code_message")) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-input" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mfaCode,
                          expression: "mfaCode"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: true, regex: /^[0-9]{6}$/ },
                          expression: "{ required: true, regex: /^[0-9]{6}$/ }"
                        }
                      ],
                      ref: "codeInput",
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("login.mfa_code"),
                        name: "mfaCode",
                        maxlength: "6",
                        "data-vv-as": _vm.$t("login.user_name")
                      },
                      domProps: { value: _vm.mfaCode },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.mfaCode = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mt-3" }, [
                    _vm._v("\n                QRコードを再表示したい場合は"),
                    _c("br"),
                    _vm._v(
                      "ワンタイムパスワードの設定をリセットする必要があります。"
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: _vm.$t("chatbot.url"), target: "_blank" }
                      },
                      [_vm._v("証憑類電子化チャットボット")]
                    ),
                    _vm._v("から"),
                    _c("br"),
                    _vm._v(
                      "\n                「STAPのワンタイムパスワードリセット」をご依頼ください。\n              "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mt-3 d-flex" }, [
                  _c("button", { staticClass: "btn btn-pink-53 w-100" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("login.login")) +
                        "\n              "
                    )
                  ])
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-gray-53 w-100",
            on: {
              click: function($event) {
                return _vm.back()
              }
            }
          },
          [_vm._v("\n        " + _vm._s(_vm.$t("button.back")) + "\n      ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo-link", attrs: { href: "#" } }, [
      _c("img", {
        attrs: { src: require("@/assets/img/logo_jtb_wht@2x.png"), alt: "Logo" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "icon-warning mr-1" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-068d63e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-068d63e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/pc/Login/LoginMfa.vue
// module id = null
// module chunks = 